import { render, staticRenderFns } from "./DashboardPicturePicker.vue?vue&type=template&id=61fad951&"
import script from "./DashboardPicturePicker.vue?vue&type=script&lang=js&"
export * from "./DashboardPicturePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports